import {Alert, Flex} from "antd";
import {Warning} from "@phosphor-icons/react";
import React from "react";
import {useViewerStore} from "../../../../../../store/store";

const RoofSquareUnavailable: React.FC = () => {

    const isRoofSquareDataUnavailable = useViewerStore((state) => state.isRoofSquareDataUnavailable);
    const roofSquareErrorMessage = useViewerStore((state) => state.roofSquareErrorMessage);

    return (
        <Flex
            vertical
            gap={10}
        >
            <Flex gap={10} justify={'left'} align={'center'}>
                <Warning className='theme-based-text-color' size={32}/>
                <span className='theme-based-text-color'>{isRoofSquareDataUnavailable ? 'Roof Square Error' : ''}</span>
            </Flex>
            <Alert
                style={{
                    color: "indianred"
                }}
                message={roofSquareErrorMessage}
                type= {isRoofSquareDataUnavailable ? 'error' : 'warning'}
                showIcon
            />
        </Flex>
    )
}

export default RoofSquareUnavailable;